import {Injectable} from '@angular/core';
import {environment} from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import {PagedRequestDTO} from '../../common/models/PagedRequestDTO';
import {Observable} from 'rxjs';
import {PagedResponseDTO} from '../../common/models/PagedResponseDTO';
import {ProviderNetworkDTO} from '../models/ProviderNetworkDTO';

@Injectable({
  providedIn: 'root'
})
export class ProviderNetworkService {
  private url = environment.baseUrl + '/provider-network';

  constructor(private httpClient: HttpClient) {
  }

  getListOfProviderNetwork(pagedRequestDTO: PagedRequestDTO): Observable<PagedResponseDTO<ProviderNetworkDTO>> {
    return this.httpClient.post<PagedResponseDTO<ProviderNetworkDTO>>(this.url + '/filter', pagedRequestDTO);
  }

  getProviderNetworkByProviderNetworkId(providerNetworkId: number): Observable<ProviderNetworkDTO> {
    return this.httpClient.get<ProviderNetworkDTO>(`${this.url}/${providerNetworkId}`);
  }

  deleteProviderNetworkBy(providerNetworkId: bigint) {
    return this.httpClient.delete<{}>(this.url + '/' + providerNetworkId);
  }

  saveProviderNetwork(providerNetworkDTO: ProviderNetworkDTO): Observable<ProviderNetworkDTO> {
    return this.httpClient.post<ProviderNetworkDTO>(this.url, providerNetworkDTO);
  }
}
